// export const environment = {
//   test: 'sssss',
//   wallet: {
//     raveKey: 'FLWPUBK_TEST-bf40c1f05cf24c79c4dbc96cd436ea8c-X',
//     itemsPerPage: 10,
//     startPageageNumebr: 1,
//     maximumTopAmount: 200,
//   },
//   scsoftUrl: {
//     base: 'https://cctest.tps.ng/',
//     path: 'nigeriacc/api/mobileApplicationService2/',
//     generalPath: 'nigeriacc/api/generalApplicationService1/',
//   },
//   reportUrl: 'https://nrcreport.secureid-digital.com.ng/',
//   apiUrl: 'https://nrcreport.secureid-digital.com.ng/',
//   xClientKey: '8eWaJqdd7tcYGDpL27JqavaUHES6qVknLS977XVP',
//   flwPubKey: 'FLWPUBK_TEST-dae76399bd210372969dd27ac5dc8e3f-X',
//   version: ' v1.0.26',
// };

export const environment = {
  production: false,
  wallet: {
    raveKey: 'FLWPUBK_TEST-bf40c1f05cf24c79c4dbc96cd436ea8c-X',
    itemsPerPage: 10,
    startPageageNumebr: 1,
    maximumTopAmount: 200,
  },
  scsoftUrl: {
    /* SCSoft Production base url */
    base: 'https://connect.tps.ng/', // prod
    /* SCSoft Test base url */
    // base: 'https://cctest.tps.ng/', // dev
    path: 'nigeriacc/api/mobileApplicationService2/',
    generalPath: 'nigeriacc/api/generalApplicationService1/',
  },
  /* SIDD Prod url */
  reportUrl: 'https://nrc-report.tps.ng/',
  // reportUrl: 'https://nrcreport-dev-api.secureid-digital.com.ng/',

  apiUrl: 'https://report.tps.ng/',
  ninVerificationUrl: 'https://nin-verification.secureid-digital.com.ng/',
  // apiUrl: 'https://nrcreport-dev-api.secureid-digital.com.ng/',
  // apiUrl: 'https://trxn-logic.tps.ng/',
  /* SIDD Test url */
  // reportUrl: 'https://nrcreport.secureid-digital.com.ng/',
  /* SIDD Test url */
  // apiUrl: 'https://nrcreport.secureid-digital.com.ng/',
  // xClientKey: '8eWaJqdd7tcYGDpL27JqavaUHES6qVknLS977XVP',
  flwPubKey: 'FLWPUBK-34055da505daabd3ee4c6c7829bb1af7-X',
  // flwPubKey: 'FLWPUBK_TEST-dae76399bd210372969dd27ac5dc8e3f-X',
  recaptcha: {
    siteKey: '6LdAuzQsAAAAAIg4AYSbVR64rt9RNTGWU9nfgcH8',
  },
  auth: {
    password: { encKey: '2019SCS@FT9876MOB9098762', encIv: 'drowssapdrowssap' },
    bvn: { encKey: '239e939601f8a07b412ab40b', encIv: 'ed3f6225882a756a' },
  },
  version: ' v2.0.36',
};
